import api from '../../store/config/api';
import {
  PROCESS as SCHEMA,
  PROCESS_LIST as PROCESS_LIST_SCHEMA
} from '../../schemas';
import { format } from '../../util/url';

export const [
  GET_PROCESS,
  GET_PROCESS_REQUEST,
  GET_PROCESS_SUCCESS,
  GET_PROCESS_FAILURE
] = api.buildTypes('GET_PROCESS');

export function getProcess({ teamName, processID, includeChildren = false }) {
  return {
    type: GET_PROCESS,
    payload: {
      url: `/teams/${teamName}/processes/${processID}?includeChildren=${includeChildren}`,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  ADD_PROCESS,
  ADD_PROCESS_REQUEST,
  ADD_PROCESS_SUCCESS,
  ADD_PROCESS_FAILURE
] = api.buildTypes('ADD_PROCESS');

export function addProcess({ teamName, data }) {
  return {
    type: ADD_PROCESS,
    payload: {
      url: `/teams/${teamName}/processes`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: data
      }
    }
  };
}

export const [
  UPDATE_PROCESS,
  UPDATE_PROCESS_REQUEST,
  UPDATE_PROCESS_SUCCESS,
  UPDATE_PROCESS_FAILURE
] = api.buildTypes('UPDATE_PROCESS');

export function updateProcess({ teamName, processID, data }) {
  const url = format({
    pathname: `/teams/${teamName}/processes/${processID}`,
    query: { retroactive: data.retroactive }
  });
  return {
    type: UPDATE_PROCESS,
    payload: {
      url,
      schema: SCHEMA,
      options: {
        method: 'PUT',
        body: data
      }
    }
  };
}

export const [
  LINK_PROCESS_TABLE,
  LINK_PROCESS_TABLE_REQUEST,
  LINK_PROCESS_TABLE_SUCCESS,
  LINK_PROCESS_TABLE_FAILURE
] = api.buildTypes('LINK_PROCESS_TABLE');

export const linkProcessTable = ({ teamName, processID, tableID }) => ({
  type: LINK_PROCESS_TABLE,
  payload: {
    url: `/teams/${teamName}/processes/${processID}/tables/${tableID}`,
    schema: {},
    options: {
      method: 'POST'
    }
  }
});

export const [
  UNLINK_PROCESS_TABLE,
  UNLINK_PROCESS_TABLE_REQUEST,
  UNLINK_PROCESS_TABLE_SUCCESS,
  UNLINK_PROCESS_TABLE_FAILURE
] = api.buildTypes('UNLINK_PROCESS_TABLE');

export const unlinkProcessTable = ({ teamName, processID, tableID }) => ({
  type: UNLINK_PROCESS_TABLE,
  payload: {
    url: `/teams/${teamName}/processes/${processID}/tables/${tableID}`,
    schema: {},
    options: {
      method: 'DELETE'
    }
  }
});

export const [
  LINK_PROCESS_PREDICTOR,
  LINK_PROCESS_PREDICTOR_REQUEST,
  LINK_PROCESS_PREDICTOR_SUCCESS,
  LINK_PROCESS_PREDICTOR_FAILURE
] = api.buildTypes('LINK_PROCESS_PREDICTOR');

export const linkProcessPredictor = ({ teamName, processID, predictorID }) => ({
  type: LINK_PROCESS_PREDICTOR,
  payload: {
    url: `/teams/${teamName}/processes/${processID}/predictors/${predictorID}`,
    schema: {},
    options: {
      method: 'POST'
    }
  }
});

export const [
  UNLINK_PROCESS_PREDICTOR,
  UNLINK_PROCESS_PREDICTOR_REQUEST,
  UNLINK_PROCESS_PREDICTOR_SUCCESS,
  UNLINK_PROCESS_PREDICTOR_FAILURE
] = api.buildTypes('UNLINK_PROCESS_PREDICTOR');

export const unlinkProcessPredictor = ({
  teamName,
  processID,
  predictorID
}) => ({
  type: UNLINK_PROCESS_PREDICTOR,
  payload: {
    url: `/teams/${teamName}/processes/${processID}/predictors/${predictorID}`,
    schema: {},
    options: {
      method: 'DELETE'
    }
  }
});

export const [
  LINK_PROCESS_PARENT_PROCESS,
  LINK_PROCESS_PARENT_PROCESS_REQUEST,
  LINK_PROCESS_PARENT_PROCESS_SUCCESS,
  LINK_PROCESS_PARENT_PROCESS_FAILURE
] = api.buildTypes('LINK_PROCESS_PARENT_PROCESS');

export const linkProcessParentProcess = ({
  teamName,
  processID,
  parentProcessID
}) => ({
  type: LINK_PROCESS_PARENT_PROCESS,
  payload: {
    url: `/teams/${teamName}/processes/${processID}/parentprocesses/${parentProcessID}`,
    schema: {},
    options: {
      method: 'POST'
    }
  }
});

export const [
  UNLINK_PROCESS_PARENT_PROCESS,
  UNLINK_PROCESS_PARENT_PROCESS_REQUEST,
  UNLINK_PROCESS_PARENT_PROCESS_SUCCESS,
  UNLINK_PROCESS_PARENT_PROCESS_FAILURE
] = api.buildTypes('UNLINK_PROCESS_PARENT_PROCESS');

export const unlinkProcessParentProcess = ({
  teamName,
  processID,
  parentProcessID
}) => ({
  type: UNLINK_PROCESS_PARENT_PROCESS,
  payload: {
    url: `/teams/${teamName}/processes/${processID}/parentprocesses/${parentProcessID}`,
    schema: {},
    options: {
      method: 'DELETE'
    }
  }
});

export const [
  GET_PROCESS_PARENT_PROCESSES,
  GET_PROCESS_PARENT_PROCESSES_REQUEST,
  GET_PROCESS_PARENT_PROCESSES_SUCCESS,
  GET_PROCESS_PARENT_PROCESSES_FAILURE
] = api.buildTypes('GET_PROCESS_PARENT_PROCESSES');

export function getProcessParentProcesses({ teamName, processID }) {
  return {
    type: GET_PROCESS_PARENT_PROCESSES,
    payload: {
      url: `/teams/${teamName}/processes/${processID}/parentprocesses`,
      schema: PROCESS_LIST_SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/process.js